export const config = {

    
    // apiUrl: 'http://127.0.0.1:8000/api',
    // imageUrl: 'http://127.0.0.1:8000/storage',
    // videoUrl: 'http://127.0.0.1:8000/storage'

    apiUrl: 'https://api.danialdigitalacademy.com/api',
    baseUrl: 'https://api.danialdigitalacademy.com/',
    imageUrl: 'https://api.danialdigitalacademy.com/storage',
    videoUrl: 'https://api.danialdigitalacademy.com/storage',
    webUrl: 'https://danialdigitalacademy.com',
};
